import { useFormContext } from "react-hook-form";
import {
  findAdIndexById,
  findAdsGroupIndexById,
  toAdsGroupsList,
} from "../../../utils/adsGroupsList";

export const useAdGroupSelection = () => {
  const { watch, sectionSelected } = useFormContext();
  const adsGroups = toAdsGroupsList(watch("adsGroups"));
  const adGroupID = sectionSelected?.adGroupID;
  const index = findAdsGroupIndexById({ adsGroups, adGroupID });
  const isReady = index >= 0;
  const adGroup = isReady ? adsGroups[index] : undefined;

  return {
    adsGroups,
    adGroupID,
    index,
    adGroup,
    isReady,
    BASIC_PATH: isReady ? `adsGroups.[${index}]` : null,
  };
};

export const useAdSelection = () => {
  const { watch, sectionSelected } = useFormContext();
  const adsGroups = toAdsGroupsList(watch("adsGroups"));
  const adGroupID = sectionSelected?.adGroupID;
  const adID = sectionSelected?.adID;
  const indexAdGroup = findAdsGroupIndexById({ adsGroups, adGroupID });
  const adGroup = indexAdGroup >= 0 ? adsGroups[indexAdGroup] : undefined;
  const indexAd = findAdIndexById({ ads: adGroup?.ads, adID });
  const isReady = indexAdGroup >= 0 && indexAd >= 0;
  const ad = isReady ? adGroup.ads[indexAd] : undefined;

  return {
    adsGroups,
    adGroupID,
    adID,
    indexAdGroup,
    indexAd,
    adGroup,
    ad,
    isReady,
    BASIC_PATH_AD_GROUP: isReady ? `adsGroups.[${indexAdGroup}]` : null,
    BASIC_PATH: isReady ? `adsGroups.[${indexAdGroup}].ads.[${indexAd}]` : null,
  };
};
